export const ENV_CONFIG = {
  // API Configuration - Use REACT_APP_ prefix as required by React
  BACKOFFICE_URL: process.env.REACT_APP_API_URL || 'https://api.recrutementcdp.juniorisep.com',
  
  // App Configuration
  NODE_ENV: process.env.NODE_ENV || 'development',
  PORT: process.env.PORT || '3002',
  
  // Environment checks
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};
